import type { MatchData } from "./types";

// ==================================================
// TOURNAMENT INSTANCE IDs
// ==================================================

const SIX_NATIONS_WOMEN_2026 = "six-nations-women-2026";
const WOMENS_TESTS_2026 = "womens-tests-2026";
const WXV1_2026 = "wxv1-2026";
const WXV_CHALLENGER_2026 = "wxv-challenger-2026";

// ==================================================
// WOMEN'S MATCHES 2026
// ==================================================

export const matches2026Women: MatchData[] = [

  // ==================================================
  // WOMEN'S SIX NATIONS 2026 — COMPLETE
  // ==================================================

  // ----- ROUND 1 (FINAL) -----
  {
    id: 1,
    matchKey: "france-w-vs-italy-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 1",
    date: "2026-04-11",
    venue: "Stade des Alpes, Grenoble",
    home: { name: "France W", country: "france" },
    away: { name: "Italy W", country: "italy" },
    score: { home: 40, away: 7 },
    state: "final",
  },
  {
    id: 2,
    matchKey: "england-w-vs-ireland-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 1",
    date: "2026-04-11",
    venue: "Twickenham, London",
    home: { name: "England W", country: "england" },
    away: { name: "Ireland W", country: "ireland" },
    score: { home: 33, away: 12 },
    state: "final",
  },
  {
    id: 3,
    matchKey: "wales-w-vs-scotland-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 1",
    date: "2026-04-11",
    venue: "Principality Stadium, Cardiff",
    home: { name: "Wales W", country: "wales" },
    away: { name: "Scotland W", country: "scotland" },
    score: { home: 19, away: 24 },
    state: "final",
  },

  // ----- ROUND 2 (FINAL) -----
  {
    id: 4,
    matchKey: "scotland-w-vs-england-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 2",
    date: "2026-04-18",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland W", country: "scotland" },
    away: { name: "England W", country: "england" },
    score: { home: 7, away: 84 },
    state: "final",
  },
  {
    id: 5,
    matchKey: "wales-w-vs-france-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 2",
    date: "2026-04-18",
    venue: "Cardiff Arms Park, Cardiff",
    home: { name: "Wales W", country: "wales" },
    away: { name: "France W", country: "france" },
    score: { home: 7, away: 38 },
    state: "final",
  },
  {
    id: 6,
    matchKey: "ireland-w-vs-italy-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 2",
    date: "2026-04-18",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland W", country: "ireland" },
    away: { name: "Italy W", country: "italy" },
    score: { home: 57, away: 20 },
    state: "final",
  },

  // ----- ROUND 3 (FINAL) -----
  {
    id: 7,
    matchKey: "england-w-vs-wales-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 3",
    date: "2026-04-25",
    venue: "Ashton Gate, Bristol",
    home: { name: "England W", country: "england" },
    away: { name: "Wales W", country: "wales" },
    score: { home: 62, away: 24 },
    state: "final",
  },
  {
    id: 8,
    matchKey: "italy-w-vs-scotland-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 3",
    date: "2026-04-25",
    venue: "Stadio Sergio Lanfranchi, Parma",
    home: { name: "Italy W", country: "italy" },
    away: { name: "Scotland W", country: "scotland" },
    score: { home: 41, away: 14 },
    state: "final",
  },
  {
    id: 9,
    matchKey: "france-w-vs-ireland-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 3",
    date: "2026-04-25",
    venue: "Stade Marcel Michelin, Clermont-Ferrand",
    home: { name: "France W", country: "france" },
    away: { name: "Ireland W", country: "ireland" },
    score: { home: 26, away: 7 },
    state: "final",
  },

  // ----- ROUND 4 (FINAL) -----
  {
    id: 10,
    matchKey: "italy-w-vs-england-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 4",
    date: "2026-05-09",
    venue: "Stadio Sergio Lanfranchi, Parma",
    home: { name: "Italy W", country: "italy" },
    away: { name: "England W", country: "england" },
    score: { home: 33, away: 61 },
    state: "final",
  },
  {
    id: 11,
    matchKey: "scotland-w-vs-france-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 4",
    date: "2026-05-09",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland W", country: "scotland" },
    away: { name: "France W", country: "france" },
    score: { home: 28, away: 69 },
    state: "final",
  },
  {
    id: 12,
    matchKey: "ireland-w-vs-wales-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 4",
    date: "2026-05-09",
    venue: "Aviva Stadium, Dublin",
    home: { name: "Ireland W", country: "ireland" },
    away: { name: "Wales W", country: "wales" },
    score: { home: 33, away: 12 },
    state: "final",
  },

  // ----- ROUND 5 (FINAL) -----
  {
    id: 13,
    matchKey: "wales-w-vs-italy-w",
    competitionId: "six-nations-women",
    tournamentInstanceId: SIX_NATIONS_WOMEN_2026,
    tournament: "Women's Six Nations 2026",
    gender: "women",
    round: "Round 5",
    date: "2026-05-17",
    venue: "Cardiff Arms Park, Cardiff",
    home: { name: "Wales W", country: "wales" },
    away: { name: "Italy W", country: "italy" },
    score: { home: 17, away: 23 },
    state: "final",
  },

  // ==================================================
  // WOMEN'S INTERNATIONAL TESTS 2026
  // ==================================================

  // ----- South Africa vs USA Series -----
  {
    id: 100,
    matchKey: "south-africa-w-vs-usa-w-20260704",
    competitionId: "womens-internationals",
    tournamentInstanceId: WOMENS_TESTS_2026,
    tournament: "Women's International Tests 2026",
    gender: "women",
    round: "Series Match 1",
    date: "2026-07-04",
    venue: "Ellis Park, Johannesburg",
    home: { name: "South Africa W", country: "south-africa" },
    away: { name: "USA W", country: "united-states-of-america" },
    score: { home: 34, away: 21 },
    state: "final",
  },
  {
    id: 101,
    matchKey: "south-africa-w-vs-usa-w-20260711",
    competitionId: "womens-internationals",
    tournamentInstanceId: WOMENS_TESTS_2026,
    tournament: "Women's International Tests 2026",
    gender: "women",
    round: "Series Match 2",
    date: "2026-07-11",
    venue: "Loftus Versfeld, Pretoria",
    home: { name: "South Africa W", country: "south-africa" },
    away: { name: "USA W", country: "united-states-of-america" },
    score: { home: 19, away: 26 },
    state: "final",
  },

  // ----- Japan Women vs Fiji Women -----
  {
    id: 102,
    matchKey: "japan-w-vs-fiji-w",
    competitionId: "womens-internationals",
    tournamentInstanceId: WOMENS_TESTS_2026,
    tournament: "Women's International Tests 2026",
    gender: "women",
    round: "Test Match",
    date: "2026-09-04",
    venue: "Japan Base, Fukuoka",
    home: { name: "Japan W", country: "japan" },
    away: { name: "Fiji W", country: "fiji" },
    score: { home: 12, away: 15 },
    state: "final",
  },

  // ----- South Africa Women vs New Zealand Women -----
  {
    id: 103,
    matchKey: "south-africa-w-vs-new-zealand-w",
    competitionId: "womens-internationals",
    tournamentInstanceId: WOMENS_TESTS_2026,
    tournament: "Women's International Tests 2026",
    gender: "women",
    round: "Test Match",
    date: "2026-09-05",
    venue: "FNB Stadium, Johannesburg",
    home: { name: "South Africa W", country: "south-africa" },
    away: { name: "New Zealand W", country: "new-zealand" },
    score: { home: 20, away: 52 },
    state: "final",
  },

  // ----- South Africa vs Ireland Series -----
  {
    id: 104,
    matchKey: "south-africa-w-vs-ireland-w-20261024",
    competitionId: "womens-internationals",
    tournamentInstanceId: WOMENS_TESTS_2026,
    tournament: "Women's International Tests 2026",
    gender: "women",
    round: "Test Match",
    date: "2026-10-24",
    venue: "Athlone Stadium, Cape Town",
    home: { name: "South Africa W", country: "south-africa" },
    away: { name: "Ireland W", country: "ireland" },
    state: "upcoming",
    startTime: "TBD",
  },
  {
    id: 105,
    matchKey: "south-africa-w-vs-ireland-w-20261031",
    competitionId: "womens-internationals",
    tournamentInstanceId: WOMENS_TESTS_2026,
    tournament: "Women's International Tests 2026",
    gender: "women",
    round: "Test Match",
    date: "2026-10-31",
    venue: "Athlone Stadium, Cape Town",
    home: { name: "South Africa W", country: "south-africa" },
    away: { name: "Ireland W", country: "ireland" },
    state: "upcoming",
    startTime: "TBD",
  },

  // ==================================================
  // WXV GLOBAL SERIES 2026 (WXV 1)
  // ==================================================

  // ----- ROUND 1 -----
  {
    id: 200,
    matchKey: "england-w-vs-australia-w",
    competitionId: "wxv1",
    tournamentInstanceId: WXV1_2026,
    tournament: "WXV Global Series 2026",
    gender: "women",
    stage: "Pool",
    round: "Round 1",
    date: "2026-09-12",
    venue: "CorpAcq Stadium, Salford",
    home: { name: "England W", country: "england" },
    away: { name: "Australia W", country: "australia" },
    score: { home: 48, away: 15 },
    state: "final",
  },
  {
    id: 201,
    matchKey: "scotland-w-vs-canada-w",
    competitionId: "wxv1",
    tournamentInstanceId: WXV1_2026,
    tournament: "WXV Global Series 2026",
    gender: "women",
    stage: "Pool",
    round: "Round 1",
    date: "2026-09-12",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland W", country: "scotland" },
    away: { name: "Canada W", country: "canada" },
    score: { home: 26, away: 64 },
    state: "final",
  },
  {
    id: 202,
    matchKey: "france-w-vs-new-zealand-w",
    competitionId: "wxv1",
    tournamentInstanceId: WXV1_2026,
    tournament: "WXV Global Series 2026",
    gender: "women",
    stage: "Pool",
    round: "Round 1",
    date: "2026-09-12",
    venue: "Matmut Stadium de Gerland, Lyon",
    home: { name: "France W", country: "france" },
    away: { name: "New Zealand W", country: "new-zealand" },
    score: { home: 14, away: 28 },
    state: "final",
  },

// ----- FRIDAY 18 SEPTEMBER 2026 -----
// ----- ROUND 2 -----

{
  id: 203,
  matchKey: "wales-w-vs-south-africa-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-18",
  venue: "Cardiff Arms Park, Cardiff",
  home: { name: "Wales W", country: "wales" },
  away: { name: "South Africa W", country: "south-africa" },
   score: { home: 50, away: 19 },
  state: "final",
  startTime: "20:15",
},

// ----- SATURDAY 19 SEPTEMBER 2026 -----

{
  id: 204,
  matchKey: "england-w-vs-canada-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-19",
  venue: "Sandy Park, Exeter",
  home: { name: "England W", country: "england" },
  away: { name: "Canada W", country: "canada" },
  score: { home: 26, away: 26 },
  state: "final",
  startTime: "16:00",
},
{
  id: 205,
  matchKey: "scotland-w-vs-new-zealand-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-19",
  venue: "Hive Stadium, Edinburgh",
  home: { name: "Scotland W", country: "scotland" },
  away: { name: "New Zealand W", country: "new-zealand" },
  score: { home: 14, away: 66 },
  state: "final",
  startTime: "17:10",
},
{
  id: 206,
  matchKey: "france-w-vs-australia-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-19",
  venue: "Matmut Stadium de Gerland, Lyon",
  home: { name: "France W", country: "france" },
  away: { name: "Australia W", country: "australia" },
  score: { home: 29, away: 26 },
  state: "final",
  startTime: "17:45",
},
{
  id: 207,
  matchKey: "italy-w-vs-japan-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-19",
  venue: "Stadio Omero Tognon, Fontanafredda",
  home: { name: "Italy W", country: "italy" },
  away: { name: "Japan W", country: "japan" },
  score: { home: 55, away: 21 },
  state: "final",
  startTime: "14:30",
},

  // ----- ROUND 3 -----

  {
    id: 208,
  matchKey: "italy-w-vs-south-africa-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 3",
  date: "2026-09-26",
  venue: "Stadio Omero Tognon, Fontanafredda",
  home: { name: "Italy", country: "italy" },
  away: { name: "South Africa", country: "south-africa" },
  score: { home: 29, away: 37 },
    state: "final",
  startTime: "14:30",
  },
  {
    id: 209,
    matchKey: "england-w-vs-new-zealand-w",
    competitionId: "wxv1",
    tournamentInstanceId: WXV1_2026,
    tournament: "WXV Global Series 2026",
    gender: "women",
    stage: "Pool",
    round: "Round 3",
    date: "2026-09-26",
    venue: "Twickenham, London",
    home: { name: "England W", country: "england" },
    away: { name: "New Zealand W", country: "new-zealand" },
    score: { home: 26, away: 19 },
    state: "final",
    startTime: "TBD",
  },
  {
    id: 210,
    matchKey: "scotland-w-vs-australia-w",
    competitionId: "wxv1",
    tournamentInstanceId: WXV1_2026,
    tournament: "WXV Global Series 2026",
    gender: "women",
    stage: "Pool",
    round: "Round 3",
    date: "2026-09-26",
    venue: "Murrayfield, Edinburgh",
    home: { name: "Scotland W", country: "scotland" },
    away: { name: "Australia W", country: "australia" },
    score: { home: 10, away: 30 },
    state: "final",
  },
  {
    id: 211,
    matchKey: "france-w-vs-canada-w",
    competitionId: "wxv1",
    tournamentInstanceId: WXV1_2026,
    tournament: "WXV Global Series 2026",
    gender: "women",
    stage: "Pool",
    round: "Round 3",
    date: "2026-09-26",
    venue: "Matmut Stadium de Gerland, Lyon",
    home: { name: "France W", country: "france" },
    away: { name: "Canada W", country: "canada" },
    score: { home: 21, away: 5 },
    state: "final",
  },
{
  id: 212,
  matchKey: "wales-w-vs-usa-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 3",
  date: "2026-09-26",
  venue: "Cardiff Arms Park, Cardiff",
  home: { name: "Wales", country: "wales" },
  away: { name: "USA", country: "usa" },
  score: { home: 24, away: 26 },
    state: "final",
  startTime: "16:00",
},
{
  id: 213,
  matchKey: "ireland-w-vs-japan-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 3",
  date: "2026-09-27",
  venue: "Dexcom Stadium, Galway",
  home: { name: "Ireland", country: "ireland" },
  away: { name: "Japan", country: "japan" },
  score: { home: 31, away: 24 },
  state: "final",
  startTime: "13:45",
},

// ----- ROUND 4 -----

{
  id: 214,
  matchKey: "canada-w-vs-england-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 4",
  date: "2026-10-16",
  venue: "BMO Field, Toronto",
  home: { name: "Canada", country: "canada" },
  away: { name: "England", country: "england" },
  score: { home: 24, away: 21 },
  state: "final",
  startTime: "01:00",
},

{
  id: 215,
  matchKey: "australia-w-vs-scotland-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 4",
  date: "2026-10-17",
  venue: "Stadium Australia, Sydney",
  home: { name: "Australia", country: "australia" },
  away: { name: "Scotland", country: "scotland" },
  score: { home: 56, away: 12 },
  state: "final",
  startTime: "03:00",
},

{
  id: 216,
  matchKey: "new-zealand-w-vs-france-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 4",
  date: "2026-10-17",
  venue: "FMG Stadium Waikato, Hamilton",
  home: { name: "New Zealand", country: "new-zealand" },
  away: { name: "France", country: "france" },
  score: { home: 81, away: 12 },
  state: "final",
  startTime: "04:05",
},

{
  id: 217,
  matchKey: "usa-w-vs-italy-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 4",
  date: "2026-10-17",
  venue: "Texas Health Mansfield Stadium, Mansfield",
  home: { name: "USA", country: "usa" },
  away: { name: "Italy", country: "italy" },
  score: { home: 36, away: 27 },
  state: "final",
  startTime: "23:00",
},

// ----- ROUND 5 -----

{
  id: 218,
  matchKey: "australia-w-vs-scotland-w-r5",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 5",
  date: "2026-10-23",
  venue: "GIO Stadium, Canberra",
  home: { name: "Australia", country: "australia" },
  away: { name: "Scotland", country: "scotland" },
  score: { home: 38, away: 31 },
  state: "final",
  startTime: "09:45",
},

{
  id: 219,
  matchKey: "canada-w-vs-england-w-r5",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 5",
  date: "2026-10-24",
  venue: "TD Place Stadium, Ottawa",
  home: { name: "Canada", country: "canada" },
  away: { name: "England", country: "england" },
  score: { home: 31, away: 22 },
  state: "final",
  startTime: "00:00",
},

{
  id: 220,
  matchKey: "new-zealand-w-vs-france-w-r5",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 5",
  date: "2026-10-24",
  venue: "Okara Park / Semenoff Stadium, Whangārei",
  home: { name: "New Zealand", country: "new-zealand" },
  away: { name: "France", country: "france" },
 score: { home: 31, away: 12 },
  state: "final",
  startTime: "03:05",
},

{
  id: 221,
  matchKey: "japan-w-vs-wales-w-r5",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 5",
  date: "2026-10-24",
  venue: "Prince Chichibu Memorial Stadium, Tokyo",
  home: { name: "Japan", country: "japan" },
  away: { name: "Wales", country: "wales" },
  score: { home: 0, away: 17 },
  state: "final",
  startTime: "10:30",
},

{
  id: 222,
  matchKey: "south-africa-w-vs-ireland-w-r5",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 5",
  date: "2026-10-24",
  venue: "Athlone Stadium, Cape Town",
  home: { name: "South Africa", country: "south-africa" },
  away: { name: "Ireland", country: "ireland" },
  score: { home: 27, away: 40 },
  state: "final",
  startTime: "14:00",
},

{
  id: 223,
  matchKey: "usa-w-vs-italy-w-r5",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 5",
  date: "2026-10-24",
  venue: "Geodis Park, Nashville",
  home: { name: "USA", country: "usa" },
  away: { name: "Italy", country: "italy" },
  score: { home: 54, away: 24 },
  state: "final",
  startTime: "21:15",
},

// ==================================================
// WXV GLOBAL SERIES 2026 – ROUND 6
// ==================================================

{
  id: 224,
  matchKey: "usa-w-vs-england-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 6",
  date: "2026-10-30",
  venue: "Sports Illustrated Stadium, Harrison, New Jersey",
  home: { name: "USA", country: "usa" },
  away: { name: "England", country: "england" },
  score: { home: 12, away: 55 },
  state: "final",
  startTime: "17:15",
},

{
  id: 225,
  matchKey: "new-zealand-w-vs-france-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 6",
  date: "2026-10-31",
  venue: "One New Zealand Stadium, Christchurch",
  home: { name: "New Zealand", country: "new-zealand" },
  away: { name: "France", country: "france" },
  score: { home: 36, away: 7 },
  state: "final",
  startTime: "19:10",
},

{
  id: 226,
  matchKey: "japan-w-vs-wales-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 6",
  date: "2026-10-31",
  venue: "Kumagaya Rugby Stadium, Kumagaya",
  home: { name: "Japan", country: "japan" },
  away: { name: "Wales", country: "wales" },
  score: { home: 5, away: 29 },
  state: "final",
  startTime: "16:00",
},

{
  id: 227,
  matchKey: "south-africa-w-vs-ireland-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 6",
  date: "2026-10-31",
  venue: "Athlone Stadium, Cape Town",
  home: { name: "South Africa", country: "south-africa" },
  away: { name: "Ireland", country: "ireland" },
  score: { home: 17, away: 38 },
  state: "final",
  startTime: "15:00",
},

  // ==================================================
  // WXV GLOBAL SERIES CHALLENGER 2026
  // ==================================================

 {
  id: 300,
  matchKey: "spain-w-vs-fiji-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 1",
  date: "2026-09-13",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Spain W", country: "spain" },
  away: { name: "Fiji W", country: "fiji" },
  score: { home: 32, away: 38 },
  state: "final",
},
 {
  id: 301,
  matchKey: "hong-kong-china-w-vs-brazil-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 1",
  date: "2026-09-13",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Hong Kong China W", country: "hong-kong-china" },
  away: { name: "Brazil W", country: "brazil" },
  score: { home: 29, away: 24 },
  state: "final",
},
 {
  id: 302,
  matchKey: "netherlands-w-vs-samoa-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 1",
  date: "2026-09-13",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Netherlands W", country: "netherlands" },
  away: { name: "Samoa W", country: "samoa" },
  score: { home: 70, away: 0 },
  state: "final",
},

// ==================================================
// WXV GLOBAL SERIES CHALLENGER 2026 — ROUND 2
// ==================================================

// ----- SATURDAY 19 SEPTEMBER 2026 -----

{
  id: 303,
  matchKey: "samoa-w-vs-spain-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-19",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Samoa W", country: "samoa" },
  away: { name: "Spain W", country: "spain" },
  score: { home: 21, away: 61 },
  state: "final",
},
{
  id: 304,
  matchKey: "fiji-w-vs-hong-kong-china-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-19",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Fiji W", country: "fiji" },
  away: { name: "Hong Kong China W", country: "hong-kong-china" },
  score: { home: 54, away: 26 },
  state: "final",
},
{
  id: 305,
  matchKey: "brazil-w-vs-netherlands-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  stage: "Pool",
  round: "Round 2",
  date: "2026-09-19",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Brazil W", country: "brazil" },
  away: { name: "Netherlands W", country: "netherlands" },
  score: { home: 15, away: 17 },
  state: "final",
},

// ==================================================
// WXV GLOBAL SERIES CHALLENGER 2026 — ROUND 3
// ==================================================

// ----- SATURDAY 26 SEPTEMBER 2026 -----

{
  id: 306,
  matchKey: "fiji-w-vs-netherlands-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  round: "Round 3",
  date: "2026-09-26",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Fiji", country: "fiji" },
  away: { name: "Netherlands", country: "netherlands" },
  score: { home: 20, away: 17 },
  state: "final",
  startTime: "06:00",
},
{
  id: 307,
  matchKey: "hong-kong-china-w-vs-samoa-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  round: "Round 3",
  date: "2026-09-26",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Hong Kong China", country: "hong-kong-china" },
  away: { name: "Samoa", country: "samoa" },
  score: { home: 17, away: 34 },
  state: "final",
  startTime: "09:30",
},
{
  id: 308,
  matchKey: "spain-w-vs-brazil-w",
  competitionId: "wxv-challenger",
  tournamentInstanceId: WXV_CHALLENGER_2026,
  tournament: "WXV Global Series Challenger 2026",
  gender: "women",
  round: "Round 3",
  date: "2026-09-26",
  venue: "Kai Tak Youth Sports Ground, Hong Kong",
  home: { name: "Spain", country: "spain" },
  away: { name: "Brazil", country: "brazil" },
  score: { home: 0, away: 0 },
  state: "final",
  startTime: "13:00",
},


// ----- STANDALONE MATCHES (OCTOBER 2026) -----

{
  id: 400,
  matchKey: "ireland-w-vs-japan-w-standalone",
  competitionId: "womens-internationals",
  tournamentInstanceId: WOMENS_TESTS_2026,
  tournament: "Women's International Tests 2026",
  gender: "women",
  round: "Test Match",
  date: "2026-10-03",
  venue: "Virgin Media Park, Cork",
  home: { name: "Ireland", country: "ireland" },
  away: { name: "Japan", country: "japan" },
  score: { home: 43, away: 19 },
  state: "final",
  startTime: "14:00",
},
{
  id: 401,
  matchKey: "spain-w-vs-south-africa-w",
  competitionId: "wxv1",
  tournamentInstanceId: WXV1_2026,
  tournament: "WXV Global Series 2026",
  gender: "women",
  round: "Round 4",
  date: "2026-10-04",
  venue: "Instalaciones deportivas La Cartuja, Seville",
  home: { name: "Spain", country: "spain" },
  away: { name: "South Africa", country: "south-africa" },
  score: { home: 0, away: 20 },
  state: "final",
  startTime: "TBD",
},

];